// extracted by mini-css-extract-plugin
export default {"row":"qgdYAltpu1Sn7DO81eAZ","scoreFormBox":"iJrveV722ngF3w7Dxjsc"};